import { ReactNode, useMemo } from 'react';

import { ProfileContext } from '@mint-lib/profile-helpers';

import { useService } from '../hooks/useService.js';

export const ProfileProvider = ({ children }: { children: ReactNode }) => {
  const [profileService, version] = useService({
    name: 'profile',
    watch: ['update'],
  });
  const contextValue = useMemo(
    () =>
      profileService
        ? {
            profileData: profileService.getProfileData(),
            setProfileData: profileService.setProfileData.bind(profileService),
            profileService,
          }
        : null,
    [profileService, version],
  );
  if (!contextValue) {
    console.log('No Profile instance found');
    return null;
  }

  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  );
};
